import { Component, Injector, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserLogin } from '../user-login/user-login';
import { UserSignup } from '../user-signup/user-signup';
import { Util } from '../../app/util';


@Component({
  selector: 'page-terms',
  templateUrl: 'terms.html',
})
export class TermsPage extends Util {
  
  constructor(public navCtrl: NavController, public navParams: NavParams, injector: Injector, private zone: NgZone) {
    super(injector, null);
  }

  
  dashboardPage() { this.navCtrl.push(Dashboard); }
  loginPage() { this.navCtrl.push(UserLogin); }
  signupPage() { this.navCtrl.push(UserSignup); }
  back(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.ts